import React from 'react';
import PropTypes from 'prop-types';
import ImportedProcedureUpdateCreate from 'ImportedProcedureUpdateCreate/presentation/ImportedProcedureUpdateCreate';
import {
  findAllMilestones,
  findCnsProcedureById,
  findImportedProcedureById,
  saveImportedProcedure,
} from 'Projects/service/ProjectService';

class ImportedProcedureUpdateCreateContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      importedProcedure: {
        id: null,
        milestone: null,
      },
      cnsProcedure: {
        id: '',
        name: '',
      },
      milestones: [],
    };
  }

  componentDidMount() {
    const {
      props: {
        params: {importedProcedureId},
      },
    } = this;

    if (importedProcedureId) {
      this.setState({importedProcedure: {id: importedProcedureId, milestone: null}});
      this.handleRetrieveImportedProcedure(importedProcedureId);
      this.handleRetrieveCnsProcedure(importedProcedureId);
    }
    this.handleRetrieveMilestones();
  }

  handleRetrieveCnsProcedure = async (cnsProcedureId) => {
    const cnsProcedure = await findCnsProcedureById(cnsProcedureId);

    if (cnsProcedure) {
      this.setState({cnsProcedure});
    }
  };

  handleRetrieveImportedProcedure = async (importedProcedureId) => {
    const importedProcedure = await findImportedProcedureById(importedProcedureId);

    if (importedProcedure) {
      this.setState({importedProcedure});
    }
  };

  handleSaveImportedProcedure = async () => {
    const {
      state: {importedProcedure},
      context: {router},
    } = this;

    await saveImportedProcedure(importedProcedure);

    router.push('Procedures');
  };

  handleRetrieveMilestones = async () => {
    const milestones = await findAllMilestones();

    this.setState({milestones});
  };

  handleChangeMilestone = (milestone) => {
    this.setState(({importedProcedure}) => ({
      importedProcedure: {...importedProcedure, milestone},
    }));
  };

  render() {
    const {
      state: {importedProcedure, cnsProcedure, milestones},
    } = this;

    return (
      <ImportedProcedureUpdateCreate
        importedProcedure={importedProcedure}
        cnsProcedure={cnsProcedure}
        milestones={milestones}
        onSaveImportedProcedure={this.handleSaveImportedProcedure}
        onChangeMilestone={this.handleChangeMilestone}
      />
    );
  }
}

ImportedProcedureUpdateCreateContainer.propTypes = {
  params: PropTypes.object.isRequired,
};

ImportedProcedureUpdateCreateContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default ImportedProcedureUpdateCreateContainer;
